<template>
    <div class="nevs-content">
        <NevsCard>
            <NevsTabs class="stat-tabs" v-model="activeTab" :tabs="tabs"></NevsTabs>

            <!-- Dolasci -->
            <NevsTab :model-value="activeTab" value="attendances">
                <div class="stat-filters">
                    <NevsDateField v-model="state.attendances.filters.date_from" :label="$LANG.Get('labels.dateFrom') + ':'" class="stat-filter"></NevsDateField>
                    <NevsDateField v-model="state.attendances.filters.date_to" :label="$LANG.Get('labels.dateTo') + ':'" class="stat-filter"></NevsDateField>
                    <NevsButton class="primary stat-filter-button" @click="runFilter('attendances')">
                        <i class="fa-solid fa-filter"></i> {{ $LANG.Get('buttons.applyFilter') }}
                    </NevsButton>
                </div>
                <StatisticsResult :result="state.attendances.result" :empty-text="$LANG.Get('labels.noStatisticsData')"
                                  @export="(format) => runExport('attendances', format)"></StatisticsResult>
            </NevsTab>

            <!-- Članarine -->
            <NevsTab :model-value="activeTab" value="memberships">
                <div class="stat-disclaimer">
                    <i class="fa-solid fa-circle-info"></i> {{ $LANG.Get('labels.expiringMembershipsNote') }}
                </div>
                <div class="stat-filters">
                    <NevsDateField v-model="state.memberships.filters.date_from" :label="$LANG.Get('labels.dateFrom') + ':'" class="stat-filter"></NevsDateField>
                    <NevsDateField v-model="state.memberships.filters.date_to" :label="$LANG.Get('labels.dateTo') + ':'" class="stat-filter"></NevsDateField>
                    <NevsButton class="primary stat-filter-button" @click="runFilter('memberships')">
                        <i class="fa-solid fa-filter"></i> {{ $LANG.Get('buttons.applyFilter') }}
                    </NevsButton>
                </div>
                <StatisticsResult :result="state.memberships.result" :empty-text="$LANG.Get('labels.noStatisticsData')"
                                  @export="(format) => runExport('memberships', format)"></StatisticsResult>
            </NevsTab>

            <!-- Proizvodi i usluge -->
            <NevsTab :model-value="activeTab" value="products">
                <div class="stat-disclaimer">
                    <i class="fa-solid fa-circle-info"></i> {{ $LANG.Get('labels.attendanceProductsDisclaimer') }}
                </div>
                <div class="stat-filters">
                    <NevsDateField v-model="state.products.filters.date_from" :label="$LANG.Get('labels.dateFrom') + ':'" class="stat-filter"></NevsDateField>
                    <NevsDateField v-model="state.products.filters.date_to" :label="$LANG.Get('labels.dateTo') + ':'" class="stat-filter"></NevsDateField>
                    <NevsButton class="primary stat-filter-button" @click="runFilter('products')">
                        <i class="fa-solid fa-filter"></i> {{ $LANG.Get('buttons.applyFilter') }}
                    </NevsButton>
                </div>
                <StatisticsResult :result="state.products.result" :empty-text="$LANG.Get('labels.noStatisticsData')"
                                  @export="(format) => runExport('products', format)"></StatisticsResult>
            </NevsTab>

            <!-- Treninzi -->
            <NevsTab :model-value="activeTab" value="sessions">
                <div class="stat-filters">
                    <NevsDateField v-model="state.sessions.filters.date_from" :label="$LANG.Get('labels.dateFrom') + ':'" class="stat-filter"></NevsDateField>
                    <NevsDateField v-model="state.sessions.filters.date_to" :label="$LANG.Get('labels.dateTo') + ':'" class="stat-filter"></NevsDateField>
                    <NevsSelect v-model="state.sessions.filters.session_type_id" :ajax="'select/session-types'" :nullable="true"
                                :label="$LANG.Get('fields.sessionType') + ':'" class="stat-filter"></NevsSelect>
                    <NevsButton class="primary stat-filter-button" @click="runFilter('sessions')">
                        <i class="fa-solid fa-filter"></i> {{ $LANG.Get('buttons.applyFilter') }}
                    </NevsButton>
                </div>
                <StatisticsResult :result="state.sessions.result" :empty-text="$LANG.Get('labels.noStatisticsData')"
                                  @export="(format) => runExport('sessions', format)"></StatisticsResult>
            </NevsTab>

            <!-- Notifikacije -->
            <NevsTab :model-value="activeTab" value="notifications">
                <NevsSimpleGrid :fields="notificationFields" :records="notifications.records" :clickable="false"
                                :empty-text="$LANG.Get('labels.noNotificationStats')"></NevsSimpleGrid>
                <div v-if="notificationsHasMore" class="stat-load-more">
                    <NevsButton class="primary" @click="loadNotifications(false)"><i class="fa-solid fa-chevron-down"></i> 
                        {{ $LANG.Get('buttons.loadMore') }}
                    </NevsButton>
                </div>
            </NevsTab>
        </NevsCard>
    </div>
</template>

<script>
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsDateField from "@/components/nevs/NevsDateField.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsTabs from "@/components/nevs/NevsTabs.vue";
import NevsTab from "@/components/nevs/NevsTab.vue";
import StatisticsResult from "@/components/general/StatisticsResult.vue";
import NevsSimpleGrid from "@/components/nevs/NevsSimpleGrid.vue";
import moment from "moment";

export default {
    name: "MembersStatistics",
    components: {NevsSimpleGrid, StatisticsResult, NevsTab, NevsTabs, NevsSelect, NevsDateField, NevsButton, NevsCard},
    data() {
        return {
            activeTab: 'attendances',
            tabDefs: {
                attendances: {endpoint: 'member-statistics/attendances', report: 'attendances'},
                memberships: {endpoint: 'member-statistics/memberships', report: 'memberships'},
                products: {endpoint: 'member-statistics/products', report: 'products'},
                sessions: {endpoint: 'member-statistics/sessions', report: 'sessions'}
            },
            state: {
                attendances: {filters: this.defaultFilters('attendances'), result: null},
                memberships: {filters: this.defaultFilters('memberships'), result: null},
                products: {filters: this.defaultFilters('products'), result: null},
                sessions: {filters: this.defaultFilters('sessions'), result: null}
            },
            notifications: {records: [], total: 0}
        }
    },
    computed: {
        tabs() {
            return [
                {value: 'attendances', label: this.$LANG.Get('statistics.attendances')},
                {value: 'memberships', label: this.$LANG.Get('statistics.expiringMemberships')},
                {value: 'products', label: this.$LANG.Get('statistics.attendanceProducts')},
                {value: 'sessions', label: this.$LANG.Get('statistics.sessions')},
                {value: 'notifications', label: this.$LANG.Get('statistics.notifications')}
            ];
        },
        notificationFields() {
            return [
                {name: 'month_display', label: this.$LANG.Get('labels.notificationStatsMonth')},
                {name: 'count', label: this.$LANG.Get('labels.notificationStatsCount'), align: 'R'}
            ];
        },
        notificationsHasMore() {
            return this.notifications.records.length < this.notifications.total;
        }
    },
    watch: {
        // Leaving a tab empties its data and resets its filters. Entering the notifications tab loads its data.
        activeTab(newTab, oldTab) {
            if (oldTab === 'notifications') {
                this.notifications.records = [];
                this.notifications.total = 0;
            } else {
                this.resetTab(oldTab);
            }
            if (newTab === 'notifications') {
                this.loadNotifications(true);
            }
        }
    },
    methods: {
        defaultFilters(tab) {
            let filters = {
                date_from: moment().startOf('month').format('YYYY-MM-DD'),
                date_to: moment().endOf('month').format('YYYY-MM-DD')
            };
            if (tab === 'sessions') {
                filters.session_type_id = null;
            }
            return filters;
        },
        resetTab(tab) {
            this.state[tab].filters = this.defaultFilters(tab);
            this.state[tab].result = null;
        },
        runFilter(tab) {
            let vm = this;
            this.$API.APICall('get', this.tabDefs[tab].endpoint, this.state[tab].filters, (data, success) => {
                if (success) {
                    vm.state[tab].result = data;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        loadNotifications(reset) {
            let vm = this;
            let offset = reset ? 0 : this.notifications.records.length;
            this.$API.APICall('get', 'member-statistics/notification-counts', {offset: offset}, (data, success) => {
                if (success) {
                    vm.notifications.records = reset ? data.records : vm.notifications.records.concat(data.records);
                    vm.notifications.total = data.total;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        runExport(tab, format) {
            let vm = this;
            let params = Object.assign({}, this.state[tab].filters, {report: this.tabDefs[tab].report, format: format});
            this.$API.APICall('get', 'member-statistics/export', params, (data, success) => {
                if (success) {
                    window.open(data.link);
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        }
    },
    mounted() {
        this.$store.commit('selectMenu', 'statistics');
        this.$store.commit('selectSubMenu', 'memberStatistics');
        this.$store.commit('setBreadcrumbs', [
            {label: this.$LANG.Get('modules.statistics'), link: null},
            {label: this.$LANG.Get('modules.memberStatistics'), link: null}
        ]);
    }
}
</script>

<style scoped>
.stat-tabs {
    margin-top: 18px;
    margin-bottom: 6px;
}

.stat-filters {
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-end;
    gap: 12px;
    padding: 12px;
    border-radius: 8px;
    background: #ffffff;
    border: 1px solid #e1e6ee;
}

.stat-filter {
    flex: 0 1 240px;
    min-width: 0;
}

.stat-filters .stat-filter-button {
    flex: 0 0 auto;
    padding: 13px 16px;
    margin-bottom: 5px;
}

.stat-load-more {
    margin-top: 12px;
    text-align: center;
}

.stat-disclaimer {
    margin-bottom: 12px;
    padding: 10px 12px;
    border-radius: 8px;
    background: #fff4ec;
    border: 1px solid #f4c9a8;
    color: #5e3a1e;
    font-size: 14px;
}
</style>
